var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-earth")])],1)]}}])},[_c('v-list',_vm._l((_vm.langs),function(item,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.selectLanguage(item)}}},[_c('v-list-item-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }